
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "DGOSD",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DGOSD.vue